import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error('UI crash caught', error, info?.componentStack); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-[40vh] flex items-center justify-center p-6" data-testid="error-boundary">
        <div className="max-w-md w-full rounded-xl border border-rose-200 bg-rose-50 p-5 text-sm text-rose-900 space-y-3">
          <p className="font-bold text-base">Something went wrong on this screen</p>
          <p>Your data is safe — the last action may not have saved. Go back and try again; if it keeps happening, tell us what you clicked.</p>
          <p className="text-xs text-rose-700 break-words">{String(this.state.error?.message || this.state.error).slice(0, 240)}</p>
          <div className="flex gap-2">
            <button type="button" onClick={() => this.setState({ error: null })} className="rounded-md bg-rose-700 text-white px-3 py-1.5 text-xs font-semibold" data-testid="error-boundary-retry">Try again</button>
            <button type="button" onClick={() => window.location.reload()} className="rounded-md border border-rose-300 px-3 py-1.5 text-xs font-semibold" data-testid="error-boundary-reload">Reload page</button>
          </div>
        </div>
      </div>
    );
  }
}
